module.exports = __webpack_public_path__ + "static/img/04943162.172ffb81.png";